import type { TabErrorSchemaTypes } from "@/types";

export default (
  schema: TabErrorSchemaTypes,
  fieldErrors: Record<string, string>,
) => {
  const fields = Object.keys(fieldErrors);
  const tabErrors: Record<string, boolean> = {};

  Object.keys(schema).forEach((tabName: string) => {
    tabErrors[tabName] = fields.some((field: string) => {
      // Array specific fieldErrors should transform a field pattern:
      // Example: pdf.0.name => pdf.*.name
      // So we can use the same pattern (pdf.*.name) in the tab definition map
      const fieldPattern = field.replace(/(?<=\.)\d+(?=\.)/g, "*");

      return schema[tabName]?.includes(fieldPattern);
    });
  });

  return tabErrors;
};
